import styled from 'styled-components';
import { Grid } from '../Grid/Grid';
export var StyledGridLayout = /*#__PURE__*/styled(Grid).withConfig({
  displayName: "StyledGridLayout",
  componentId: "c11n-8-111-1__sc-12y7p8e-0"
})([""]);